var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaySoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 11.4141C12.4141 11.2031 12.8594 11.2031 13.2109 11.4375L19.9609 15.5391C20.2891 15.75 20.5 16.125 20.5 16.5C20.5 16.8984 20.2891 17.2734 19.9609 17.4609L13.2109 21.5859C12.8594 21.7969 12.4141 21.8203 12.0625 21.6094C11.7109 21.4219 11.5 21.0469 11.5 20.625V12.375C11.5 11.9766 11.7109 11.6016 12.0625 11.4141ZM12.625 20.625L19.375 16.5L12.625 12.375V20.625Z",
    fill: "#303030"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#CAD0D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySoundIcon);
export default __webpack_public_path__ + "static/media/playSoundIcon.8091b76fb26741dfc4241336b0ea43e4.svg";
export { ForwardRef as ReactComponent };